// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CardMedicationModel {
    'name'?: string;
    'ndc'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CardMedicationModel>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CardMedicationModel.attributeTypeMap;
    }
}
